export const AddFundsActionIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.4"
      d="M10.7933 1.33337H5.20659C2.77992 1.33337 1.33325 2.78004 1.33325 5.20671V10.7867C1.33325 13.22 2.77992 14.6667 5.20659 14.6667H10.7866C13.2133 14.6667 14.6599 13.22 14.6599 10.7934V5.20671C14.6666 2.78004 13.2199 1.33337 10.7933 1.33337Z"
      fill="#FDFDFD"
    />
    <path
      d="M11.3334 7.49996H8.50008V4.66663C8.50008 4.39329 8.27341 4.16663 8.00008 4.16663C7.72675 4.16663 7.50008 4.39329 7.50008 4.66663V7.49996H4.66675C4.39341 7.49996 4.16675 7.72663 4.16675 7.99996C4.16675 8.27329 4.39341 8.49996 4.66675 8.49996H7.50008V11.3333C7.50008 11.6066 7.72675 11.8333 8.00008 11.8333C8.27341 11.8333 8.50008 11.6066 8.50008 11.3333V8.49996H11.3334C11.6067 8.49996 11.8334 8.27329 11.8334 7.99996C11.8334 7.72663 11.6067 7.49996 11.3334 7.49996Z"
      fill="#FDFDFD"
    />
  </svg>
);

export const TransferActionIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.4"
      d="M4.73994 3.97331L10.7533 1.96665C13.4533 1.06665 14.9199 2.53998 14.0266 5.23998L12.0199 11.2533C10.6733 15.3 8.45993 15.3 7.11327 11.2533L6.51994 9.46665L4.73327 8.87332C0.693269 7.53332 0.693269 5.32665 4.73994 3.97331Z"
      fill="#132B40"
    />
    <path d="M8.08008 7.75333L10.6201 5.20667L8.08008 7.75333Z" fill="#132B40" />
    <path
      d="M8.08012 8.25337C7.95345 8.25337 7.82679 8.20671 7.72679 8.10671C7.53345 7.91337 7.53345 7.59337 7.72679 7.40004L10.2601 4.85337C10.4535 4.66004 10.7735 4.66004 10.9668 4.85337C11.1601 5.04671 11.1601 5.36671 10.9668 5.56004L8.43345 8.10671C8.33345 8.20004 8.20679 8.25337 8.08012 8.25337Z"
      fill="#132B40"
    />
  </svg>
);

export const ConvertActionIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.4"
      d="M10.7933 1.33337H5.20659C2.77992 1.33337 1.33325 2.78004 1.33325 5.20671V10.7867C1.33325 13.22 2.77992 14.6667 5.20659 14.6667H10.7866C13.2133 14.6667 14.6599 13.22 14.6599 10.7934V5.20671C14.6666 2.78004 13.2199 1.33337 10.7933 1.33337Z"
      fill="#132B40"
    />
    <path
      d="M11.9 9.02C11.8467 8.9 11.7533 8.8 11.6267 8.74666C11.5667 8.72 11.5 8.70667 11.4333 8.70667H4.56665C4.29332 8.70667 4.06665 8.93333 4.06665 9.20667C4.06665 9.48 4.29332 9.70667 4.56665 9.70667H10.2333L9.05998 10.88C8.86665 11.0733 8.86665 11.3933 9.05998 11.5867C9.15998 11.6867 9.28665 11.7333 9.41332 11.7333C9.53998 11.7333 9.66665 11.6867 9.76665 11.5867L11.7933 9.56C11.84 9.51333 11.8733 9.46 11.9 9.4C11.9467 9.28 11.9467 9.14 11.9 9.02Z"
      fill="#132B40"
    />
    <path
      d="M4.09994 6.97998C4.15327 7.09998 4.24661 7.19998 4.37327 7.25331C4.43327 7.27998 4.49994 7.29331 4.56661 7.29331H11.4399C11.7133 7.29331 11.9399 7.06664 11.9399 6.79331C11.9399 6.51998 11.7133 6.29331 11.4399 6.29331H5.77327L6.94661 5.11998C7.13994 4.92664 7.13994 4.60664 6.94661 4.41331C6.75327 4.21998 6.43327 4.21998 6.23994 4.41331L4.21327 6.43331C4.16661 6.47998 4.12661 6.53998 4.09994 6.59998C4.05327 6.71998 4.05327 6.85998 4.09994 6.97998Z"
      fill="#3B4567"
    />
  </svg>
);

export const CreateInvoiceActionIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.4"
      d="M14 4.66671V11.3334C14 13.3334 13 14.6667 10.6667 14.6667H5.33333C3 14.6667 2 13.3334 2 11.3334V4.66671C2 2.66671 3 1.33337 5.33333 1.33337H10.6667C13 1.33337 14 2.66671 14 4.66671Z"
      fill="#132B40"
    />
    <path
      d="M12.3334 6.16667H11.0001C9.98675 6.16667 9.16675 5.34667 9.16675 4.33333V3C9.16675 2.72667 9.39341 2.5 9.66675 2.5C9.94008 2.5 10.1667 2.72667 10.1667 3V4.33333C10.1667 4.79333 10.5401 5.16667 11.0001 5.16667H12.3334C12.6067 5.16667 12.8334 5.39333 12.8334 5.66667C12.8334 5.94 12.6067 6.16667 12.3334 6.16667Z"
      fill="#132B40"
    />
    <path
      d="M7.99992 9.16663H5.33325C5.05992 9.16663 4.83325 8.93996 4.83325 8.66663C4.83325 8.39329 5.05992 8.16663 5.33325 8.16663H7.99992C8.27325 8.16663 8.49992 8.39329 8.49992 8.66663C8.49992 8.93996 8.27325 9.16663 7.99992 9.16663Z"
      fill="#3B4567"
    />
    <path
      d="M10.6666 11.8334H5.33325C5.05992 11.8334 4.83325 11.6067 4.83325 11.3334C4.83325 11.06 5.05992 10.8334 5.33325 10.8334H10.6666C10.9399 10.8334 11.1666 11.06 11.1666 11.3334C11.1666 11.6067 10.9399 11.8334 10.6666 11.8334Z"
      fill="#3B4567"
    />
  </svg>
);

export const NonActiveCreditLineIllustration = () => (
  <svg width="125" height="133" viewBox="0 0 125 133" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.4"
      d="M129.041 69.8184V118.379C128.838 137.735 123.54 142.625 103.369 142.625H39.2557C18.7449 142.625 13.583 137.531 13.583 117.292V69.8184C13.583 51.4809 17.8618 45.5721 33.958 44.6213C35.588 44.5534 37.354 44.4855 39.2557 44.4855H103.369C123.879 44.4855 129.041 49.5792 129.041 69.8184Z"
      fill="#A9BCFF"
    />
    <path
      d="M149.416 45.7079V93.1817C149.416 111.519 145.138 117.428 129.041 118.379V69.8183C129.041 49.5792 123.879 44.4854 103.369 44.4854H39.2557C37.354 44.4854 35.588 44.5533 33.958 44.6213C34.1618 25.265 39.4595 20.375 59.6307 20.375H123.744C144.254 20.375 149.416 25.4688 149.416 45.7079Z"
      fill="#A9BCFF"
    />
    <path
      d="M47.2698 126.053H35.5879C32.8033 126.053 30.4941 123.744 30.4941 120.96C30.4941 118.175 32.8033 115.866 35.5879 115.866H47.2698C50.0544 115.866 52.3635 118.175 52.3635 120.96C52.3635 123.744 50.1223 126.053 47.2698 126.053Z"
      fill="#A9BCFF"
    />
    <path
      d="M85.2354 126.053H61.8721C59.0875 126.053 56.7783 123.744 56.7783 120.96C56.7783 118.175 59.0875 115.866 61.8721 115.866H85.2354C88.02 115.866 90.3292 118.175 90.3292 120.96C90.3292 123.744 88.0879 126.053 85.2354 126.053Z"
      fill="#A9BCFF"
    />
    <path d="M129.041 80.5492H13.583V90.7367H129.041V80.5492Z" fill="#A9BCFF" />
  </svg>
);

export const HoverArrowIcon = () => (
  <svg width="48" height="38" viewBox="0 0 48 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="0.75"
      y="0.75"
      width="46.5"
      height="36.5"
      rx="7.25"
      stroke="#4F55FD"
      strokeOpacity="0.5"
      strokeWidth="1.5"
    />
    <path
      d="M24.8333 23.375L29 19L24.8333 14.625M29 19L19 19"
      stroke="#4F55FD"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
